require('./depositDetailsView.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const Immutable = require('immutable');
const { connect } = require('react-redux');
const find = require('lodash/collection/find');
const { withRouter } = require('react-router-dom');
// @ components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const AccountInterveners = require('components/accounts/accountInterveners/accountInterveners');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
// @ constants
const { EMPTY_CONCEPT } = require('constants/index');
// @ actions
const depositsActions = require('actions/deposits');
const depositChangeAccountActions = require('actions/contactCenter/depositChangeAccount');
// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

const { formatIbanString } = require('commonsUtilities/stringHelper')
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class DepositDetailsView extends React.Component {

    componentDidMount() {
        const { match: { params: { depositId } }, requestDeposits, immDeposits, requestDepositInterveners, immSavings, requestAssociatedAccount } = this.props;
        const deposit = immSavings.get('allSavings').find(option => {
            return option.get('id') === depositId;
        });

        requestAssociatedAccount(deposit);

        if (!immDeposits.getIn(['byId', depositId])) {
            requestDeposits();
        }
        else {
            requestDepositInterveners(depositId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { match: { params: { depositId } }, requestDepositInterveners } = this.props;
        if (
            nextProps.immDeposits.getIn(['byId', depositId]) &&
            !nextProps.immDeposits.getIn(['byId', depositId, 'interveners', 'isFetching']) &&
            !nextProps.immDeposits.getIn(['byId', depositId, 'interveners', 'hasBeenFetched']) &&
            nextProps.immDeposits.get('success')
        ) {
            requestDepositInterveners(depositId);
        }
    }

    buildChangeAccountLink() {
        const { match: { params: { depositId } }, immDeposits } = this.props;
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const endDate = immDeposit.getIn(['borderDates', 'endDate']);
        const closed = immDeposit.get('isClosed');
        const isInactiveDeposit = new Date(endDate) < new Date() || closed;
        const changeAccountUrl = `/myprofile/deposits/${depositId}/change-account`;

        return (
            isInactiveDeposit ? null :
            <OKButton
                to={changeAccountUrl}
                >
                {formatText('depositDetails-changeAccount')}
            </OKButton>
        );
    }
    //TODO Call service capture associated account, with contract number deposit.getIn(['contract','contractNumer']) and
    //TODO product: deposit.getIn(['contract','product'])
    buildDetailsInfo() {
        const { match: { params: { depositId } }, immDeposits, immAccounts, immSavings, immDepositChangeAccount } = this.props;
        const associatedAccountContractNumber = immDepositChangeAccount.getIn(['asociatedAccount', 'contrato', 'numerodecontrato']);
        const contractNumber = formatIbanString(immDeposits.getIn(['byId', depositId, 'contract', 'fullContractNumber']));
        const savingData = find(immSavings.get('allSavings').toJS(), (saving) =>
            saving.id === immDeposits.getIn(['byId', depositId, 'id'])
        );
        const productDescription = savingData.productDescription || immDeposits.getIn(["byId", depositId, "description"]) || EMPTY_CONCEPT;
        const headerTitle = formatText('depositDetails-headerTitle');
        const contractNumberLabel = formatText('depositDetails-contractNumberLabel');
        const productLabel = formatText('depositDetails-productLabel');
        const account = find(immAccounts.get('byId').toJS(), (account) =>
            account.contractNumber === associatedAccountContractNumber
        );
        const alias = account.alias || EMPTY_CONCEPT;
        const iban = formatIbanString(account.iban) || EMPTY_CONCEPT;
        const plainAmountObject = getPlainAmountObject(account.balances.availableBalance);
        const accountAvailableAmount = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
        const associatedAccount = `${alias} ${iban} - `;
        const changeAssociatedAccountLink = this.buildChangeAccountLink();

        return (
            <OKSectionBox>
                <header className="deposit-details__title">
                    <OKBoxTitle value={headerTitle} inline={true} />
                </header>
                <h3 className="deposit-details__subtitle">
                    <FormattedText value="depositDetails-contractInfoTitle" />
                </h3>
                <OKInformativeList columns={2}>
                    <OKInformativeListItem title={contractNumberLabel}>
                        <div className="card-transfer-money-to-checking-account-step1__value">
                            {contractNumber}
                        </div>
                    </OKInformativeListItem>
                    <OKInformativeListItem title={productLabel}>
                        <div className="card-transfer-money-to-checking-account-step1__value">
                            {productDescription}
                        </div>
                    </OKInformativeListItem>
                </OKInformativeList>
                <h3 className="deposit-details__subtitle">
                    <FormattedText value="depositDetails-associatedAccountTitle" />
                </h3>
                <div className="deposit-details__account">
                    {associatedAccount}
                    {accountAvailableAmount}
                </div>
                <div>
                    {changeAssociatedAccountLink}
                </div>
            </OKSectionBox>
        );
    }

    buildCCHeader() {
        const headerTitle = formatText('depositDetails-headerTitle');
        const breadCrumbMap = [
            {
                text: formatText('depositDetails-depositsLabelLink'),
                url: '/myprofile/deposits'
            },
            {
                text: headerTitle,
            },
        ];

        return (
            <OKHeaderCC
                title={headerTitle}
                breadcrumbConfig={breadCrumbMap}
                showBreadBrumb={true}
            />
        );
    }

    buildIntervenersData() {

        let list = [];
        const { match: { params: { depositId } }, immDeposits } = this.props;

        const immInterveners = Immutable.fromJS({
            error: immDeposits.getIn(['byId', depositId, 'interveners', 'error']),
            isLoading: immDeposits.getIn(['byId', depositId, 'interveners', 'isFetching']),
            list: []
        });
        const intervenersList = immDeposits.getIn(['byId', depositId, 'interveners', 'list']);

        intervenersList.toJS().forEach((intervener) => {
            list.push({
                identification: {
                    type: intervener.identification.type || EMPTY_CONCEPT,
                },
                identificationDocument: {
                    code: intervener.identification.code || EMPTY_CONCEPT,
                    type: intervener.identification.type || EMPTY_CONCEPT,
                },
                interventionOrder: intervener.interventionOrder || EMPTY_CONCEPT,
                isRemovable: false,
                name: intervener.name || EMPTY_CONCEPT,
                type: intervener.type || EMPTY_CONCEPT,
            })
        });

        return immInterveners.set('list', Immutable.fromJS(list));
    }

    onHandleBack() {
        this.props.history.push(`/myprofile/deposits`);
    }

    buildError() {
        const title = formatText('depositDetails-errorTitle');
        const subtitle = formatText('depositDetails-errorSubtitle');
        const textLink = formatText('depositDetails-backButton');

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                subtitle={subtitle}
                goBackHandler={() => this.onHandleBack()}
                textLink={textLink}
            />
        )
    }

    buildInterveners() {
        const { match: { params: { depositId } } } = this.props;
        const immInterveners = this.buildIntervenersData();
        return (
            <OKSectionBox>
                <AccountInterveners immInterveners={immInterveners} accountId={depositId} />
            </OKSectionBox>
        );
    }

    render() {

        const { match: { params: { depositId } }, immDeposits, immDepositChangeAccount } = this.props;
        const headerCC = this.buildCCHeader();
        let content = <LoadingSection />;

        if (
            !immDeposits.get('isFetching') &&
            immDeposits.get('hasBeenFetched') &&
            !immDeposits.getIn(['byId', depositId, 'interveners', 'isFetching'], false) &&
            immDeposits.getIn(['byId', depositId, 'interveners', 'hasBeenFetched'], false) &&
            immDeposits.getIn(['byId', depositId, 'interveners', 'list'], false) &&
            !immDeposits.getIn(['byId', depositId, 'interveners', 'error'], false) &&
            immDeposits.getIn(['byId', depositId, 'impositionAssociatedAccount', 'contractNumber']) &&
            !immDepositChangeAccount.get('isFetchingAsociatedAccount')
        ) {
            const detailsInfo = this.buildDetailsInfo();
            const interveners = this.buildInterveners();
            content = (
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position">
                            <div className="deposit-details__content grid-view--fix-cell-separation col-md-8">
                                {detailsInfo}
                            </div>
                            <div className="deposit-details__interveners grid-view--fix-cell-separation col-md-4">
                                {interveners}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        else if (
            immDeposits.getIn(['byId', depositId, 'interveners', 'error'], false)
        ) {
            content = this.buildError();
        }
        return (
            <div className="deposit-details">
                {headerCC}
                {content}
            </div>
        );
    }

}

DepositDetailsView.propTypes = {
    history: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immSavings: PropTypes.object.isRequired,
    immDepositChangeAccount: PropTypes.object.isRequired,
    requestDepositInterveners: PropTypes.func.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    requestAssociatedAccount: PropTypes.func.isRequired,
    match: PropTypes.object
};

module.exports.constructor = DepositDetailsView;
module.exports.DepositDetailsView = connect(
    state => ({
        immDeposits: state.deposits,
        immAccounts: state.accounts,
        immSavings: state.globalPosition.get('savings'),
        immDepositChangeAccount: state.depositChangeAccount
    }),
    {
        requestDepositInterveners: depositsActions.requestDepositInterveners,
        requestAssociatedAccount: depositChangeAccountActions.requestAsociatedAccount,
        requestDeposits: depositsActions.requestDeposits
    }
)(withRouter(DepositDetailsView));
